<div class="card m-3">
  <div class="card-body">

    <div class="form-header">
      <button mat-icon-button (click)="goBack()" class="back-btn" matTooltip="Back to bids">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="form-title">
        <mat-icon class="title-icon">edit_note</mat-icon>
        Edit Project Bid
      </h2>
    </div>

    <form (ngSubmit)="saveProjectBid()" #bidForm="ngForm" class="bid-form">

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Company Name</mat-label>
          <input matInput [(ngModel)]="projectBid.companyName" name="CompanyName"
                 placeholder="Enter company name" required />
          <mat-icon matSuffix>business</mat-icon>
          <mat-error>Company name is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row two-col">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Project Type</mat-label>
          <mat-select [(ngModel)]="projectBid.projectTypeId" name="ProjectType"
                      (ngModelChange)="onProjectTypeChange($event)" required>
            <mat-option *ngFor="let type of projectTypes" [value]="type.id">
              {{ type.type }}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>category</mat-icon>
          <mat-error>Project type is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="projectBid.status" name="Status" required>
            <mat-option value="Pending">Pending</mat-option>
            <mat-option value="Submitted">Submitted</mat-option>
            <mat-option value="Approved">Approved</mat-option>
            <mat-option value="Won">Won</mat-option>
            <mat-option value="Rejected">Rejected</mat-option>
            <mat-option value="Lost">Lost</mat-option>
          </mat-select>
          <mat-icon matSuffix>flag</mat-icon>
          <mat-error>Status is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Bid Amount</mat-label>
          <span matPrefix>$&nbsp;</span>
          <input matInput type="number" [(ngModel)]="projectBid.bidAmount" name="BidAmount"
                 placeholder="0.00" min="0" step="0.01" required />
          <mat-error>Bid amount is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Project Details</mat-label>
          <textarea matInput [(ngModel)]="projectBid.projectDetails" name="ProjectDetails"
                    placeholder="Describe the scope of work…"
                    rows="4" required></textarea>
          <mat-error>Project details are required</mat-error>
        </mat-form-field>
      </div>

      <!-- ── Contacts ──────────────────────────────────────────── -->
      <div class="contacts-section">
        <div class="contacts-header">
          <span class="contacts-title">
            <mat-icon>contacts</mat-icon>
            Contacts
          </span>
          <button type="button" mat-stroked-button class="add-contact-btn"
                  (click)="showContactForm = true" *ngIf="!showContactForm">
            <mat-icon>person_add</mat-icon> Add Contact
          </button>
        </div>

        <!-- Contact list -->
        <div class="contact-list" *ngIf="contacts.length > 0">
          <div class="contact-card" *ngFor="let c of contacts; let i = index">
            <div class="contact-avatar">{{ c.name[0]?.toUpperCase() }}</div>
            <div class="contact-info">
              <div class="contact-name">{{ c.name }}
                <span class="contact-title-badge" *ngIf="c.title">{{ c.title }}</span>
              </div>
              <div class="contact-details">
                <span *ngIf="c.email"><mat-icon class="detail-icon">email</mat-icon>{{ c.email }}</span>
                <span *ngIf="c.phone"><mat-icon class="detail-icon">phone</mat-icon>{{ c.phone }}</span>
              </div>
            </div>
            <button type="button" mat-icon-button color="warn" class="remove-contact-btn"
                    (click)="removeContact(i)" matTooltip="Remove contact">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <div class="no-contacts" *ngIf="contacts.length === 0 && !showContactForm">
          <mat-icon>person_outline</mat-icon>
          <span>No contacts added yet</span>
        </div>

        <!-- Inline add-contact form -->
        <div class="contact-form-inline" *ngIf="showContactForm">
          <div class="contact-form-row two-col">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Name *</mat-label>
              <input matInput [(ngModel)]="newContact.name" name="newContactName"
                     placeholder="Full name" />
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Title</mat-label>
              <input matInput [(ngModel)]="newContact.title" name="newContactTitle"
                     placeholder="e.g. Project Manager" />
              <mat-icon matSuffix>work</mat-icon>
            </mat-form-field>
          </div>
          <div class="contact-form-row two-col">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email</mat-label>
              <input matInput type="email" [(ngModel)]="newContact.email" name="newContactEmail"
                     placeholder="email@company.com" />
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Phone</mat-label>
              <input matInput [(ngModel)]="newContact.phone" name="newContactPhone"
                     placeholder="(555) 000-0000" />
              <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>
          </div>
          <div class="contact-form-actions">
            <button type="button" mat-button (click)="cancelContact()">Cancel</button>
            <button type="button" mat-raised-button color="primary"
                    [disabled]="!newContact.name.trim()" (click)="addContact()">
              <mat-icon>check</mat-icon> Add Contact
            </button>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" mat-stroked-button (click)="goBack()">Cancel</button>
        <button type="submit" mat-raised-button color="primary" [disabled]="bidForm.invalid">
          <mat-icon>save</mat-icon> Save Changes
        </button>
      </div>

    </form>
  </div>
</div>
